const nameSpacedEvents = {};

const addEvent = (el, type, handler) => {
	const [ev, namespace] = type.split('.');
	nameSpacedEvents[namespace] = handler;

	if (el.attachEvent) {
		el.attachEvent(`on${ev}`, handler);
	} else {
		el.addEventListener(ev, handler);
	}
};

const removeEvent = (el, type, handler) => {
	const [ev, namespace] = type.split('.');

	if (el.detachEvent) {
		el.detachEvent(`on${ev}`, nameSpacedEvents[namespace] !== undefined ? nameSpacedEvents[namespace] : handler);
	} else {
		el.removeEventListener(ev, nameSpacedEvents[namespace] !== undefined ? nameSpacedEvents[namespace] : handler);
	}
};

const width = (el, borderBox = true) => {
	if (el === window) {
		return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	}
	return borderBox ? el.offsetWidth : el.clientWidth;
};

const height = (el, borderBox = true) => {
	if (el === null) return 0;
	if (el === window) {
		return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	}
	return borderBox ? el.offsetHeight : el.clientHeight;
};

const offset = (el) => {
	if (!el) return { top: 0, left: 0 };
	const rect = el.getBoundingClientRect();
	const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: Math.round(rect.top + scrollTop), left: Math.round(rect.left + scrollLeft) };
};

const hasClass = (el, className) => {
	if (el.classList) {
		return el.classList.contains(className);
	}
	return new RegExp(`\\b ${className}\\b`).test(el.className);
};

const addClass = (el, className) => {
	if (className.constructor !== Array) className = [className];
	for (let i = 0; i < className.length; i += 1) {
		if (el.classList) el.classList.add(className[i]);
		else if (!hasClass(el, className)) el.className += ` ${className[i]}`;
	}
};

const removeClass = (el, className) => {
	if (className === '') {
		el.className = '';
		return;
	}
	if (className.constructor !== Array) className = [className];
	for (let i = 0; i < className.length; i += 1) {
		if (el.classList) el.classList.remove(className[i]);
		else el.className = el.className.replace(new RegExp(`\\b ${className[i]}\\b`, 'g'), '');
	}
};

export { addEvent, removeEvent, width, height, offset, hasClass, addClass, removeClass };



// WEBPACK FOOTER //
// ./utils/dom.js